module.exports = __webpack_public_path__ + "img/badge-mix.d866e770.svg";